/* Enhance the native disclosures without changing Shopify's editable block IDs. */
if (!customElements.get('atoto-claim-steps')) {
  customElements.define('atoto-claim-steps', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.steps = Array.from(this.querySelectorAll(':scope > .awfp__step'));
      if (!this.steps.length) return;
      this.initialized = true;
      const sectionId = this.closest('.awfp').id;
      const nav = document.createElement('div');
      nav.className = 'awfp__step-tabs';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', this.dataset.label);
      this.tabs = this.steps.map((step, index) => {
        const tab = document.createElement('button');
        const panel = step.querySelector('.awfp__detail');
        tab.type = 'button';
        tab.className = 'awfp__step-tab';
        tab.id = `${sectionId}-step-tab-${index}`;
        tab.setAttribute('role', 'tab');
        panel.id = `${sectionId}-step-panel-${index}`;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.tabIndex = 0;
        tab.setAttribute('aria-controls', panel.id);
        for (const child of step.querySelector('summary').children) {
          tab.append(child.cloneNode(true));
        }
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
          else if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.steps.length - 1;
          else return;
          event.preventDefault();
          next = (next + this.steps.length) % this.steps.length;
          this.select(next);
          this.tabs[next].focus({ preventScroll: true });
          this.tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
        nav.append(tab);
        return tab;
      });
      this.prepend(nav);
      this.classList.add('awfp__steps--tabs');
      this.select(0);
      // Shopify dispatches block selection on the block's actual wrapper.
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.steps.findIndex(step => step === event.target || step.contains(event.target));
        if (index !== -1) this.select(index);
      });
    }

    select(index) {
      this.steps.forEach((step, current) => {
        const active = current === index;
        step.hidden = !active;
        step.open = active;
        this.tabs[current].setAttribute('aria-selected', String(active));
        this.tabs[current].tabIndex = active ? 0 : -1;
      });
    }
  });
}
